<template>
  <v-col cols="12" class="px-8" v-if="permisoVista('dashboard','r')">
    <v-row>
      <v-col cols="3" md="3" sm="3" class="align-self-end">
        <datePicker
          v-model="desde"
          format="YYYY-MM-DD"
          :maxDate="fin"
          label="Desde (Obligatorio)"
          clearable
          maxToday
          @input="getMaquinaIns();obtenerDatos()"
          :disabled="cargando"
        ></datePicker>
      </v-col>
      <v-col cols="3" md="3" sm="3" class="align-self-end">
        <datePicker
          v-model="hasta"
          :minDate="desde"
          format="YYYY-MM-DD"
          label="Hasta (Obligatorio)"
          clearable
          maxToday
          @input="getMaquinaIns();obtenerDatos()"
          :disabled="cargando"
        ></datePicker>
      </v-col>
      <v-col cols="6" md="6" sm="6" class="align-self-end">
        <v-autocomplete
          v-model="idsMaquinasIns"
          label="Instancias de Máquinas (Obligatorio)"
          :items="maquinasIns"
          item-value="idMaquinaIns"
          :item-text="nombreMaquina"
          multiple
          clearable
          @change="obtenerDatos"
          :disabled="cargando"
          dense
          hide-details
        ></v-autocomplete>
      </v-col>
    </v-row>
    <v-row v-if="realizarPeticion" class="px-0 ma-0">
      <v-col cols="12" class="ma-0 text-right text-subtitle-2">
        Proxima Actualización en {{tiempo}}
      </v-col>
    </v-row>
    <v-progress-linear
      v-if="cargando"
			color="primary"
			height="5"
			indeterminate
		></v-progress-linear>
    <br>
    <v-simple-table v-if="!cargando">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="font-weight-bold text-center">No. de Parte</th>
            <th></th>
            <th class="font-weight-bold text-center" v-for="(fecha,idx) in fechas" :key="`fecha-${idx}`">{{fecha}}</th>
            <th class="font-weight-bold text-center">Total</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(dato,idx) in datos">
            <tr :key="`datoa-${idx}`">
              <td rowspan="5">
                {{dato.maquinaInsNombre}}
              </td>
              <td>Horas Laboradas</td>
              <td v-for="(f,j) in dato.datos" :key="`datoh-${idx}-${j}`">{{f.horas}}</td>
              <td></td>
            </tr>
            <tr :key="`datob-${idx}`">
              <td>Pza Planeadas</td>
              <td v-for="(f,j) in dato.datos" :key="`datoi-${idx}-${j}`">{{f.planeacion}}</td>
              <td>{{dato.planeacion}}</td>
            </tr>
            <tr :key="`datob-${idx}`">
              <td>Pza Realizadas</td>
              <td v-for="(f,j) in dato.datos" :key="`datoj-${idx}-${j}`">{{f.realizado}}</td>
              <td>{{dato.realizado}}</td>
            </tr>
            <tr :key="`datob-${idx}`">
              <td>% Cumplimiento Plan</td>
              <td v-for="(f,j) in dato.datos" :key="`datok-${idx}-${j}`">{{f.porcentajeEficiencia}} %</td>
              <td>{{dato.porcentajeEficiencia}} %</td>
            </tr>
            <tr :key="`datob-${idx}`">
              <td>Cumpl. Día Plan</td>
              <td v-for="(f,j) in dato.datos" :key="`datol-${idx}-${j}`">{{f.cumplimientoAcumulado}} %</td>
              <td></td>
            </tr>
          </template>
        </tbody>
      </template>
    </v-simple-table>
    <br>
    <br>
    <v-expansion-panels multiple>
      <v-expansion-panel>
        <v-expansion-panel-header>Producción Objetivo por Día</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th>Fecha / Máquina</th>
                  <th class="text-center" v-for="maquinaIns in categorias" :key="`maqIns-${maquinaIns.idMaquinaIns}`">{{maquinaIns.nombre}}</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(fecha,idx) in fechas">
                  <tr :key="`fecha-${idx}`">
                    <td>
                      {{fecha}}
                    </td>
                    <td class="text-center" v-for="(maquinaIns,idy) in categorias" :key="`dato-${idx}-${idy}`">
                      <number-input
                      :value="obtenerValor(idx,idy)"
                      controls
                      inline
                      size="small"
                      min="0"
                      center
                      @change="cambioValor($event,idx,idy)"
                    ></number-input>
                    </td>
                  </tr>
                </template>
              </tbody>
          </template>
          </v-simple-table>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header>Producción Objetivo Intervalo</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th>Fecha / Máquina</th>
                  <th class="text-center" v-for="maquinaIns in categorias" :key="`maqIns-${maquinaIns.idMaquinaIns}`">{{maquinaIns.nombre}}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {{desde}} <-> {{hasta}}
                  </td>
                  <td class="text-center" v-for="(maquinaIns,idy) in categorias" :key="`dato-${idy}`">
                    <number-input
                    controls
                    inline
                    size="small"
                    min="0"
                    center
                    @change="cambioValorRango($event,maquinaIns)"
                  ></number-input>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-col>
</template>

<script>
import axios from "axios"

export default {
  props:{
    active:{
      type: Boolean,
      default: false,
    }
  },
  computed:{
    realizarPeticion(){
      if(this.desde != null && this.hasta != null && this.$utils.isValid(this.idsMaquinasIns) && this.idsMaquinasIns.length > 0) return true;
      else return false;
      
    },
    url(){
      var url = `/Dashboard/Tabla1?Desde=${this.desde}&Hasta=${this.hasta}`;
      if(this.idsMaquinasIns.length > 0){
        this.idsMaquinasIns.forEach(idMaquinaIns => {
          url += `&IdsMaquinasIns=${idMaquinaIns}`;
        })
      }
      return url;
    },
    tiempo(){
      return this.$utils.strings.toTime(this.segundos);
    }
  },
  data: () => ({
    interval: null,
    segundos: 60,
    cargando: false,
    desde: null,
    hasta:null,
    fechas: [],
    datos: [],
    categorias:[],
    maquinasIns:[],
    idsMaquinasIns: [],
    objetivos: [],
  }),
  methods:{
    nombreMaquina: maquina => ` [${maquina.nombre}] - ${maquina.marca} ${maquina.modelo}`,
    obtenerValor(x,y){
      if(this.$utils.isValid(this.objetivos[x])){
        if(this.$utils.isValid(this.objetivos[x][y])){
          return this.$utils.isValid(this.objetivos[x][y]) ? this.objetivos[x][y] : 0;
        }
        else return 0;
      }
      else return 0;
    },
    obtenerDatos(){
      if(!this.realizarPeticion || this.cargando) return;

      this.cargando = true;
      this.segundos = 60;

      axios
      .get(this.url)
      .then(response => {
        this.categorias = response.data.maquinaInstancias;
        this.objetivos = response.data.objetivos;
        this.fechas = response.data.fechas;
        this.datos = response.data.datos;
        this.cargando = false;
      })
      .catch(error => {
        this.cargando = false;
        console.log(error);
      })
    },
    getMaquinaIns(){
      if(this.desde==null || this.hasta==null){
        this.maquinasIns = [];
        return;
      }
      axios
      .get("/MaquinaInstancias/MaquinasConOperaciones",{
        params:{
          fechaInicio: this.desde,
          fechaFin: this.hasta
        }
      })
      .then(response => {
        this.maquinasIns = response.data;
      })
      .catch(error => {
        console.log(error);
      })
    },
    cambioValor(event,idxFechas,idxMaquinaIns){
      if(event <= 0 || this.obtenerValor(idxFechas,idxMaquinaIns) == event) return;
      
      axios
      .post("/MaquinaInstanciaObjetivos/CrearActualizar",{
        idMaquinaIns: this.categorias[idxMaquinaIns].idMaquinaIns,
        cantidadObjetivo: event, 
        fecha: this.fechas[idxFechas].substr(this.fechas[idxFechas].indexOf("] ")+2)
      })
      .then(() => {
        this.obtenerDatos();
      })
      .catch(error => {
        console.log(error);
      })
    },
    cambioValorRango(event,maquinaIns){
      if(event <= 0) return;

      axios
      .put("/MaquinaInstanciaObjetivos/CrearActualizarRangoFechasObjetivo",{
        idMaquinaIns: maquinaIns.idMaquinaIns,
        cantidad: event, 
        rangoInicio: this.desde,
        rangoFin: this.hasta,
      })
      .then(() => {
        this.obtenerDatos();
      })
      .catch(error => {
        console.log(error);
      })
    }
  },
  mounted(){
    this.interval = setInterval(() => {
      if(!this.active) return;

      if(this.segundos == 0) {
        this.obtenerDatos();
      }
      else this.segundos -= 1;
    },1000);
  },
  destroyed(){
    clearInterval(this.interval);
  }
}
</script>